import Button from "components/common/Button";
import Input from "components/common/Input";
import api from "config/api";
import { useState } from "react";
import { toast } from "react-toastify";

type Props = {
  value: number;
  onSubmit: (v: string) => void;
};

const inititalData = {
  nameOnCard: "",
  cardNumber: "",
  expiryDate: "",
  cardCVC: "",
};
const Clover = ({ value, onSubmit }: Props) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(inititalData);

  const handleSubmit = () => {
    toast.dismiss();
    if (!data.nameOnCard) {
      toast.error("Invalid Cardholder Name");
      return;
    }
    if (data.cardNumber.length !== 16) {
      toast.error("Invalid Card Number");
      return;
    }
    if (
      !data.expiryDate ||
      !/\b(0[1-9]|1[0-2])\/?([0-9]{4}|[0-9]{2})\b/.test(data.expiryDate)
    ) {
      toast.error("Invalid Expiry Date");
      return;
    }
    if (!/^\d+$/.test(data.cardCVC) || data.cardCVC.length !== 3) {
      toast.error("Invalid Card CVV");
      return;
    }
    setLoading(true);
    api
      .post("/api/Clover", { ...data, amount: +value.toFixed(2) })
      .then(({ data }) => {
        if (data?.status === "succeeded") {
          onSubmit("CLOVER");
        } else {
          onSubmit("CLOVER");
          toast.error("Something went wrong1222");
        }
      })
      .catch((e) => {
        onSubmit("CLOVER");
        console.log("🚀 - handleSubmit - e:", e);
        toast.error("Something went wrong");
      })
      .finally(() => setLoading(false));
  };

  return (
    <div className="flex flex-col gap-2.5 mt-2 px-4">
      <Input
        size="small"
        type="text"
        required
        label="Cardholder Name"
        value={data.nameOnCard}
        onValueChange={(nameOnCard) =>
          setData((e) => ({ ...e, nameOnCard: nameOnCard.toUpperCase() }))
        }
      />
      <Input
        size="small"
        type="text"
        required
        label="Card Number"
        placeholder="0000 0000 0000 0000"
        value={data.cardNumber}
        onValueChange={(cardNumber) => {
          const isInValid = isNaN(+cardNumber) || cardNumber.length > 16;
          setData((e) => ({
            ...e,
            cardNumber: isInValid ? e.cardNumber : cardNumber,
          }));
        }}
      />
      <div className="flex gap-2">
        <Input
          size="small"
          type="text"
          required
          className="flex-1"
          placeholder="MM/YYYY"
          label="Expiration"
          value={data.expiryDate}
          onValueChange={(v) => {
            const cleaned = v.replace(/[^\d]/g, "");

            let formatted = "";

            if (cleaned.length === 0) {
              formatted = "";
            } else if (cleaned.length === 1) {
              formatted = cleaned;
            } else if (cleaned.length === 2) {
              const monthNum = parseInt(cleaned, 10);
              if (monthNum > 12) {
                // Shift logic: first digit = month, second digit = start of year
                const month = "0" + cleaned[0];
                const yearStart = cleaned[1];
                formatted = `${month}/${yearStart}`;
              } else {
                formatted = cleaned;
              }
            } else {
              let month = cleaned.slice(0, 2);
              let year = cleaned.slice(2, 6);

              const monthNum = parseInt(month, 10);
              if (monthNum > 12) {
                // Shift: first digit is month, rest is year
                const shiftedMonth = "0" + cleaned[0];
                const shiftedYear = cleaned.slice(1, 6);
                formatted = `${shiftedMonth}/${shiftedYear}`;
              } else {
                formatted = `${month}/${year}`;
              }
            }

            setData((e) => ({ ...e, expiryDate: formatted }));
          }}
        />
        <Input
          size="small"
          type="text"
          required
          label="CVV"
          className="flex-1"
          value={data.cardCVC}
          onValueChange={(cardCVC) => {
            if (cardCVC.length > 3) return;
            setData((e) => ({ ...e, cardCVC }));
          }}
        />
      </div>
      <Button disabled={loading} onClick={handleSubmit}>
        PAY
      </Button>
    </div>
  );
};

export default Clover;
